import { notes } from "../constants"
import useSetlist from "../hooks/useSetlist"
import { useStorePads } from "../store"

export default function FormSetList({ onSubmit }) {
    const { libraries } = useStorePads()
    const { toSongList } = useSetlist()

    const handleSubmit = (e) => {
        e.preventDefault()

        const data = Object.fromEntries(new FormData(e.target))
        toSongList({
            ...data,
            bpm: Number(data.bpm),
            measures: Number(data.measures),
            metronomeEnabled: data.metronomeEnabled === 'on',
            fixed: true
        })
        onSubmit?.()
        e.target.reset()
    }

    return (
        <form onSubmit={handleSubmit}>
            <h4 className="font-bold text-xl py-4">Nueva Canción</h4>
            <div className="flex flex-col gap-2">
                <div>
                    <label>Nombre de la canción:</label>
                    <input className="w-full" type="text" name="title" placeholder="Nombre de la canción" />
                </div>
                <div className="flex flex-col">
                    <label>Tonalidad:</label>
                    <select className="bg-neutral-950" name="key">
                        {
                            notes.map((note) => (
                                <option key={note} value={note}>
                                    {note}
                                </option>
                            ))
                        }
                    </select>
                </div>
                <div className="flex flex-col">
                    <label>Sonido:</label>
                    <select className="bg-neutral-950" name="library">
                        {
                            libraries.filter(l => !l.disabled).map((library) => (
                                <option key={library.name} value={library.name}>
                                    {library.name}
                                </option>
                            ))
                        }
                    </select>
                </div>
                <div className="grid grid-cols-2 gap-2">
                    <div className="flex flex-col">
                        <label>BPM:</label>
                        <input className="w-full" type="number" name="bpm" min="30" max="300" defaultValue="120" />
                    </div>
                    <div className="flex flex-col">
                        <label>Compases:</label>
                        <input className="w-full" type="number" name="measures" min="2" max="8" defaultValue="4" />
                    </div>
                </div>
                <label className="flex items-center gap-2 py-1">
                    <input type="checkbox" name="metronomeEnabled" />
                    Activar metrónomo al cargar
                </label>
                <div className="py-2 flex items-center justify-end">
                    <button>Agregar Canción</button>
                </div>
            </div>
        </form>
    )
}

